

export function formatToISO(dateStr) {
  const date = new Date(dateStr);
  return date.toISOString();
}